"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=wearable-definition.js.map